import { query, createAsync } from "@solidjs/router";
import { _listCarts } from "../roma-api/cart";

export const listCarts = query(() => _listCarts(), "carts");

export const useListCarts = (options = { deferStream: false }) =>
  createAsync(() => listCarts(), options);
